import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
	routes: [{
			path: "/",
			// component: () => import('@/page/mymain'),
			component: () => import('@/page/Main_whole'),
			meta: {
				title: "颐倍康开放平台管理系统",
			},
			children: [{ //老人管理
					path: "", // 默认（进入页面默认展示页面）//old-list
					name: "老人数据列表",
					component: () => import('@/page/platform-module/old-manage/older_list'),
					meta: {
						parentTitle: "老人管理",
						title: "老人数据列表", //可以做面包屑
					}
				},
				{ //老人管理
					path: "old-file",
					component: () => import('@/page/platform-module/old-manage/older_file'),
				},
				{ //数据管理
					path: "bed-list",
					name: "床位设备列表",
					component: () => import('@/page/platform-module/data-manage/equipment/bed_list'),
					meta: {
						parentTitle: "数据管理",
						title: "床位设备列表",
					}
				},
				{ //数据管理
					path: "health-list",
					name: "健康数据列表",
					component: () => import('@/page/platform-module/data-manage/health_list'),
					meta: {
						parentTitle: "数据管理",
						title: "健康数据列表",
					}
				},
				{ //数据管理
					path: "position-list",
					name: "定位数据列表",
					component: () => import('@/page/platform-module/data-manage/position_list'),
					meta: {
						parentTitle: "数据管理",
						title: "定位数据列表",
					}
				},
				{ //平台管理
					path: "plat-list",
					name: "平台列表",
					component: () => import('@/page/platform-module/plat-manage/plat_list'),
					meta: {
						parentTitle: "平台管理",
						title: "平台列表",
					}
				}, { //检测列表（设备监测数据）
					path: "device-bind",
					name: "设备绑定列表",
					component: () => import('@/page/platform-module/plat-manage/deviceBind/device_bind'),
					meta: {
						parentTitle: "平台管理",
						title: "设备绑定列表", //面包屑
					}

				},
				{ //用户管理
					path: "user-list",
					name: "用户列表",
					component: () => import('@/page/platform-module/user-manage/user_list'),
					meta: {
						parentTitle: "用户管理",
						title: "用户列表",
					}
				},
				{ //日志管理
					path: "daily-list",
					name: "日志列表",
					component: () => import('@/page/platform-module/daily-manage/daily_list'),
					meta: {
						parentTitle: "日志管理",
						title: "日志列表", //面包屑
					}
				},
				{ //接口文档/获取token
					path: "gain-token",
					name: "获取token",
					component: () => import('@/page/platform-module/jog-document/gain_token'),
					meta: {
						parentTitle: "接口文档",
						title: "获取token", //面包屑
					}

				}, { //接口文档/添加老人
					path: "add-older",
					name: "添加老人",
					component: () => import('@/page/platform-module/jog-document/add_older'),
					meta: {
						parentTitle: "接口文档",
						title: "添加老人", //面包屑
					}

				}, { //接口文档/添加老人定位数据
					path: "add-oldPosition",
					name: "添加老人定位数据",
					component: () => import('@/page/platform-module/jog-document/add_oldPosition'),
					meta: {
						parentTitle: "接口文档",
						title: "添加老人定位数据", //面包屑
					}

				}, { //接口文档/添加监测数据
					path: "add-surveyData",
					name: "添加监测数据",
					component: () => import('@/page/platform-module/jog-document/add_surveyData'),
					meta: {
						parentTitle: "接口文档",
						title: "添加监测数据", //面包屑
					}

				}, { //科医智能网关列表
					path: "kyk-push",
					name: "科医智能网关列表",
					component: () => import('@/page/platform-module/kyk-push/kyk_push'),
					meta: {
						parentTitle: "科医智能网关",
						title: "科医智能网关列表", //面包屑
					}

				}, { //检测列表（设备监测数据）
					path: "monitor",
					name: "设备监测数据",
					component: () => import('@/page/platform-module/testing/monitor_list'),
					meta: {
						parentTitle: "检测列表",
						title: "设备监测数据", //面包屑
					}

				}, { //安装人员
					path: "admin",
					name: "服务人员",
					component: () => import('@/page/platform-module/admin/admin'),
					meta: {
						parentTitle: "表单设计",
						title: "服务人员", //面包屑
					}
				}, { //安装人员
					path: "diction-list",
					name: "字典数据",
					component: () => import('@/page/platform-module/admin/dictionData/diction_list'),
					meta: {
						parentTitle: "表单设计",
						title: "字典数据", //面包屑
					}
				}, { //表单
					path: "form-data",
					name: "模板列表",
					component: () => import('@/page/platform-module/admin/formData/form_list'),
					meta: {
						parentTitle: "表单设计",
						title: "模板列表", //面包屑
					}
				}, { //表单
					path: "form-list",
					name: "表单列表",
					component: () => import('@/page/platform-module/admin/formList/form_list'),
					meta: {
						parentTitle: "表单设计",
						title: "表单列表", //面包屑
					}
				}
			]
		},
		{ //登录
			path: "/login",
			component: () => import('@/page/login'),
			meta: {
				title: "颐倍康开放平台管理系统",
			}
		}, { //注册
			path: "/register",
			component: () => import('@/page/register.vue'),
			meta: {
				title: "颐倍康开放平台管理系统",
			}
		}, { //实时
			path: "/real-time",
			component: () => import('@/page/platform-module/data-manage/equipment/statis/real_time.vue'),
			meta: {
				title: "颐倍康开放平台管理系统",
			}
		}, { //实时
			path: "/report_list",
			component: () => import('@/page/platform-module/data-manage/equipment/operate/report_list.vue'),
			meta: {
				title: "颐倍康开放平台管理系统",
			}
		}

	]
});

//导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆

// import {
// 	_
// } from "@/utils"
//是全局导航钩子：router.beforeEach(to,from,next)，作用：跳转前进行判断拦截
// var signoutBool = sessionStorage.getItem('loginUser');
// this.signoutShow = JSON.parse(signoutBool);

// router.beforeEach(function(to, from, next) {
// 	if (!localStorage.getItem("loginUser")) {
// 		if (to.path !== "/login") {
// 			return next("/login")
// 		}
// 	}
// 	// _.startLoading()
// 	document.title = to.meta.title
// 	next()
// });
import {
	_
} from "@/utils"
router.beforeEach(function(to, from, next) {
		if (to.path == "/register") { //点击前往注册可以路由跳转注册页面
			next()
		} else if (to.path == "/login") { //点击前往登录可以路由跳转登录页面
			next()
		} else if (to.path == "/real-time") { //点击前往登录可以路由跳转登录页面
			next()
		} else if (to.path == "/report_list") { //点击前往登录可以路由跳转登录页面
			next()
		} else if (!sessionStorage.getItem("loginUser")) { //判断是否有‘loginUser’,没有（则为真）则执行下一步
			if (to.path !== "/login") { //如果去的不是/login则返回/login
				return next("/login")
			}
		} else {
			next()
		}
		// document.title=to.meta.title//作用于子路由
		_.startLoading()
		document.title = to.matched[0].meta.title //只作用于父路由，这个to可以直接跟meta,但是如果有子路由镶嵌就会出问题所以还是推荐使用这种方式
		next()
	}),
	router.afterEach(() => {
		setTimeout(function() {
			_.stopLoading()
		}, 1000)
	})



export default router
